var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoinIconBright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1658_18802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7596,
    cy: 41.7596,
    r: 41.7596,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1658_18802)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9836 71.1328C87.1281 54.9883 87.1281 28.813 70.9836 12.6685C54.8391 -3.47602 28.6638 -3.47602 12.5193 12.6685C-3.6252 28.8129 -3.6252 54.9883 12.5193 71.1328C28.6638 87.2773 54.8391 87.2773 70.9836 71.1328Z",
    fill: "url(#paint0_linear_1658_18802)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4561 69.6015C84.7549 54.3027 84.7549 29.4985 69.4561 14.1998C54.1573 -1.09899 29.3531 -1.09899 14.0544 14.1998C-1.24439 29.4985 -1.24439 54.3027 14.0544 69.6015C29.3531 84.9003 54.1573 84.9003 69.4561 69.6015Z",
    fill: "url(#paint1_linear_1658_18802)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.2564 76.0294C19.2895 72.9994 7.12508 58.9997 6.99903 42.1457C6.85625 22.9845 22.3291 7.27987 41.4903 7.13709C50.7728 7.06839 59.526 10.6176 66.1381 17.1323C72.7502 23.647 76.4302 32.3464 76.4995 41.6284C76.5682 50.9103 73.019 59.6635 66.5043 66.2762C59.9896 72.8882 51.2908 76.5677 42.0082 76.637C39.7011 76.6543 37.4429 76.4446 35.2564 76.03V76.0294ZM47.9716 9.46996C45.8621 9.0697 43.6989 8.87315 41.5028 8.88928C32.6893 8.955 24.4284 12.4486 18.2422 18.728C12.0561 25.0067 8.68551 33.319 8.75122 42.1326C8.81693 50.9467 12.3112 59.207 18.5899 65.3932C24.8692 71.5787 33.1798 74.9493 41.9951 74.8836C50.8086 74.8179 59.0696 71.3242 65.2557 65.0449C71.4413 58.7662 74.8124 50.4544 74.7461 41.6403C74.6804 32.8268 71.1868 24.5658 64.9074 18.3797C60.1927 13.7348 54.3304 10.6767 47.971 9.46936L47.9716 9.46996Z",
    fill: "url(#paint2_linear_1658_18802)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9766 31.7821C27.9766 30.819 28.7592 30.0388 29.7246 30.0388H39.8626C40.828 30.0388 41.6106 30.8196 41.6106 31.7821V59.6785C41.6106 60.6416 40.828 61.4218 39.8626 61.4218H29.7246C28.7592 61.4218 27.9766 60.641 27.9766 59.6785V31.7821Z",
    fill: "#FFD93D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1242 26.7894C43.1242 25.4416 44.2199 24.3484 45.5712 24.3484H60.096C62.2747 24.3484 63.3674 26.9746 61.8284 28.5129L47.3025 43.0383C45.7618 44.579 43.123 43.4905 43.123 41.3141V26.7888L43.1242 26.7894Z",
    fill: "#FFD93D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8984 62.0297C46.933 62.0297 46.1504 61.2489 46.1504 60.2864V50.6359C46.1504 49.0922 48.0143 48.3102 49.1207 49.3891L59.0143 59.0396C60.1345 60.1323 59.359 62.0297 57.792 62.0297H47.8984Z",
    fill: "#FFD93D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6016 19.9742C25.9252 41.295 45.8484 56.7572 69.4805 57.4733C64.0166 67.1434 53.6444 73.6725 41.7451 73.6725C24.162 73.6724 9.9082 59.4187 9.9082 41.8356C9.90824 33.3702 13.2127 25.6771 18.6016 19.9742Z",
    fill: "url(#paint3_linear_1658_18802)",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9766 29.7774C27.9766 28.8144 28.7592 28.0342 29.7246 28.0342H39.8626C40.828 28.0342 41.6106 28.815 41.6106 29.7774V57.6739C41.6106 58.6369 40.828 59.4171 39.8626 59.4171H29.7246C28.7592 59.4171 27.9766 58.6363 27.9766 57.6739V29.7774Z",
    fill: "#FFA500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1242 24.7844C43.1242 23.4366 44.2199 22.3434 45.5712 22.3434H60.096C62.2747 22.3434 63.3674 24.9696 61.8284 26.5079L47.3025 41.0332C45.7618 42.574 43.123 41.4855 43.123 39.3091V24.7838L43.1242 24.7844Z",
    fill: "#FFA500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8984 60.0247C46.933 60.0247 46.1504 59.2439 46.1504 58.2814V48.6309C46.1504 47.0872 48.0143 46.3052 49.1207 47.3841L59.0143 57.0346C60.1345 58.1273 59.359 60.0247 57.792 60.0247H47.8984Z",
    fill: "#FFA500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1658_18802",
    x1: -10.9328,
    y1: 6.09311,
    x2: 113.339,
    y2: 90.5568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFA020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF9010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFB330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FFF590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFFF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFFD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1658_18802",
    x1: 13.93,
    y1: 70.1445,
    x2: 77.0573,
    y2: 6.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.220876,
    stopColor: "#FFB330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543048,
    stopColor: "#FFE570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1658_18802",
    x1: 7.6025,
    y1: 35.4004,
    x2: 75.8956,
    y2: 48.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFB330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFA020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF9010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FF8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF9010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFB330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FFF590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFFF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFFD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFD860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1658_18802",
    x1: 56.9563,
    y1: 30.4347,
    x2: 23.2214,
    y2: 64.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDD0",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoinIconBright);
export default __webpack_public_path__ + "static/media/Koin_icon_bright.f6631346d31148d8e887915d8ee34d7a.svg";
export { ForwardRef as ReactComponent };